import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-digital",
  "use": "calendar-digital-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 22\" id=\"calendar-digital\"><path d=\"M20.5 1a2 2 0 012 2v12a2 2 0 01-2 2h-8.001l.001 3h3a1 1 0 01.117 1.994L15.5 22h-8a1 1 0 01-.117-1.993L7.5 20h3l-.001-3H2.5a2 2 0 01-2-2V3a2 2 0 012-2h18zm-.2 2.2H2.7v11.6h17.6V3.2z\" fill=\"#2D2D2D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol